import { Dialog, Grid } from '@material-ui/core';
import { DialogCloseButton } from 'library';
import React, { useState } from 'react';
import { UserPostModel } from '../../NewsfeedModels';
import ComingSoon from '../components/ComingSoon';
import Confirmation from '../components/Confirmation';
import UserProfile from './components/UserProfile';

interface IProps {
    open: boolean;
    user: UserPostModel;
    onClose: () => void;
}

export default function UserProfileModal({ user, onClose, open }: IProps) {
    const [page, setPage] = useState(0);

    function handleClose() {
        setPage(0);
        onClose();
    }

    function renderContent() {
        switch (page) {
            case 0:
                return <UserProfile user={user} onMessageClick={() => setPage(1)} />;

            case 1:
                return (
                    <Grid container style={{ padding: 30 }}>
                        <ComingSoon setSection={() => setPage(2)} large={true} />
                    </Grid>
                );
            case 2:
                return (
                    <Grid container style={{ padding: 30 }}>
                        <Confirmation large={true} />
                    </Grid>
                );
        }
    }
    return (
        <Dialog open={open} onClose={handleClose} maxWidth={'sm'}>
            <DialogCloseButton onClose={handleClose} />
            {renderContent()}
        </Dialog>
    );
}
